<div class="container">
  <div class="segment" *ngFor="let item of distribution" [style.--width]="item.amount" [ngClass]="setClass(item.type)"></div>
</div>
